export enum CookieKeys {
  access_token = "access_token",
  refresh_token = "refresh_token",
  language = "NEXT_LOCALE", //Don't change it, nextjs specifications
  branch_id = "branch_id",
  branch_clear_ts = "branch_clear_ts",
  agent_id = "agent_id",
  currency_code = "currency_code",
  fbp = "_fbp",
  fbc = "_fbc",
  ttp = "_ttp",
  ttclid = "ttclid",
  fb_login_id = "fb_login_id",
  ip = "request-ip",
  rewriteURLs = "rewrite-urls",
  company_id = "company_id",
  twclid = "twclid",
  /** Testing only — forces the geo country. See middleware-helpers/geo-country.ts. */
  debug_country = "debug_country",

  reset_last_viewed = "RESET_LAST_VIEWED",
}
